// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"input_wrapper__3EiZ2","root":"input_root__3HQsT","error":"input_error__24YVP"};